import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getSupplierApi = createAsyncThunk("client/supplier-list`", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/supplier/api/v1/supplier-list`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("Supplier response", response);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching Supplierr:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch supplierr");
  }
});

// create supplier

export const createSupplierApi = createAsyncThunk("client/create-supplier", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/supplier/api/v1/create-supplier`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("Create Supplier response", response);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error creating Suppliers:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to create suppliers");
  }
});

// update supplier

export const updateSupplierApi = createAsyncThunk("client/update-supplier", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  console.log(`Update supplier id `, data.rowId);

  try {
    const response = await axios.put(`${baseUrl}admin/supplier/api/v1/update-supplier/${data.rowId}`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("Update Supplier response", response);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error updating Suppliers:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to update suppliers");
  }
});

// delete supplier

export const deleteSupplierApi = createAsyncThunk("client/delete-supplier", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/supplier/api/v1/delete-supplier/${data}`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("Delete Supplier response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error deleting Suppliers:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to delete suppliers");
  }
});

// get supplier count
export const getSupplierCountApi = createAsyncThunk("client/supplier-count", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.get(`${baseUrl}admin/supplier/api/v1/supplier-count`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("Supplier count response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching supplier count:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch supplier count");
  }
});
